export default __webpack_public_path__ + "static/media/ScanAnytime.3a84353c0501c7912ab0bbb6f9c1476c.webp";